module.exports = __webpack_public_path__ + "static/media/youtube.c4121ae8.svg";